export default __webpack_public_path__ + "static/player_avatars_storycard-19cd99ceca314c3eaf30c61e00f5aab4.png";